
<ngx-datatable
class="bootstrap"
[rows]="books"
[columnMode]="'force'"
[headerHeight]="50"
[footerHeight]="50"
[rowHeight]="'auto'"
[loadingIndicator]="loadingIndicator"
[reorderable]="reorderable"
>
<ngx-datatable-column name="Title" prop="title"></ngx-datatable-column>
<ngx-datatable-column name="ISBN" prop="isbn"></ngx-datatable-column>
<ngx-datatable-column name="Writer" prop="writer.name"></ngx-datatable-column>
<ngx-datatable-column name="Publisher" prop="publisher.name"></ngx-datatable-column>
<ngx-datatable-column name="Edition" prop="edition"></ngx-datatable-column>
<!-- <ngx-datatable-column name="Price" prop="price"></ngx-datatable-column> -->
<ngx-datatable-column name="Category" prop="category.category_name"></ngx-datatable-column>
<ngx-datatable-column name="Actions">
  <ng-template ngx-datatable-cell-template let-row="row">
    <!-- <button class="btn btn-sm btn-primary" (click)="edit(row)">Edit</button> -->
    <button class="btn btn-sm btn-outline-primary" (click)="openViewDialog(row)">View</button>
  </ng-template>
</ngx-datatable-column>
</ngx-datatable>
